/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { WorkRelatedIdentifierDTO } from './WorkRelatedIdentifierDTO';
import {
    WorkRelatedIdentifierDTOFromJSON,
    WorkRelatedIdentifierDTOFromJSONTyped,
    WorkRelatedIdentifierDTOToJSON,
    WorkRelatedIdentifierDTOToJSONTyped,
} from './WorkRelatedIdentifierDTO';
import type { WorkDescriptionDTO } from './WorkDescriptionDTO';
import {
    WorkDescriptionDTOFromJSON,
    WorkDescriptionDTOFromJSONTyped,
    WorkDescriptionDTOToJSON,
    WorkDescriptionDTOToJSONTyped,
} from './WorkDescriptionDTO';
import type { WorkHasPartDTO } from './WorkHasPartDTO';
import {
    WorkHasPartDTOFromJSON,
    WorkHasPartDTOFromJSONTyped,
    WorkHasPartDTOToJSON,
    WorkHasPartDTOToJSONTyped,
} from './WorkHasPartDTO';
import type { WorkProjectDTO } from './WorkProjectDTO';
import {
    WorkProjectDTOFromJSON,
    WorkProjectDTOFromJSONTyped,
    WorkProjectDTOToJSON,
    WorkProjectDTOToJSONTyped,
} from './WorkProjectDTO';
import type { WorkProjectOtherDTO } from './WorkProjectOtherDTO';
import {
    WorkProjectOtherDTOFromJSON,
    WorkProjectOtherDTOFromJSONTyped,
    WorkProjectOtherDTOToJSON,
    WorkProjectOtherDTOToJSONTyped,
} from './WorkProjectOtherDTO';
import type { WorkLanguageDTO } from './WorkLanguageDTO';
import {
    WorkLanguageDTOFromJSON,
    WorkLanguageDTOFromJSONTyped,
    WorkLanguageDTOToJSON,
    WorkLanguageDTOToJSONTyped,
} from './WorkLanguageDTO';
import type { WorkPublisherDTO } from './WorkPublisherDTO';
import {
    WorkPublisherDTOFromJSON,
    WorkPublisherDTOFromJSONTyped,
    WorkPublisherDTOToJSON,
    WorkPublisherDTOToJSONTyped,
} from './WorkPublisherDTO';
import type { SubjectDTO } from './SubjectDTO';
import {
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
    SubjectDTOToJSONTyped,
} from './SubjectDTO';
import type { UrlDTO } from './UrlDTO';
import {
    UrlDTOFromJSON,
    UrlDTOFromJSONTyped,
    UrlDTOToJSON,
    UrlDTOToJSONTyped,
} from './UrlDTO';
import type { WorkOrganisationOtherDTO } from './WorkOrganisationOtherDTO';
import {
    WorkOrganisationOtherDTOFromJSON,
    WorkOrganisationOtherDTOFromJSONTyped,
    WorkOrganisationOtherDTOToJSON,
    WorkOrganisationOtherDTOToJSONTyped,
} from './WorkOrganisationOtherDTO';
import type { WorkPlaceDTO } from './WorkPlaceDTO';
import {
    WorkPlaceDTOFromJSON,
    WorkPlaceDTOFromJSONTyped,
    WorkPlaceDTOToJSON,
    WorkPlaceDTOToJSONTyped,
} from './WorkPlaceDTO';
import type { WorkDateTypeDTO } from './WorkDateTypeDTO';
import {
    WorkDateTypeDTOFromJSON,
    WorkDateTypeDTOFromJSONTyped,
    WorkDateTypeDTOToJSON,
    WorkDateTypeDTOToJSONTyped,
} from './WorkDateTypeDTO';
import type { AdminDataWorkDTO } from './AdminDataWorkDTO';
import {
    AdminDataWorkDTOFromJSON,
    AdminDataWorkDTOFromJSONTyped,
    AdminDataWorkDTOToJSON,
    AdminDataWorkDTOToJSONTyped,
} from './AdminDataWorkDTO';
import type { WorkGeoLocationDTO } from './WorkGeoLocationDTO';
import {
    WorkGeoLocationDTOFromJSON,
    WorkGeoLocationDTOFromJSONTyped,
    WorkGeoLocationDTOToJSON,
    WorkGeoLocationDTOToJSONTyped,
} from './WorkGeoLocationDTO';
import type { WorkIsPartOfDTO } from './WorkIsPartOfDTO';
import {
    WorkIsPartOfDTOFromJSON,
    WorkIsPartOfDTOFromJSONTyped,
    WorkIsPartOfDTOToJSON,
    WorkIsPartOfDTOToJSONTyped,
} from './WorkIsPartOfDTO';
import type { EventDTO } from './EventDTO';
import {
    EventDTOFromJSON,
    EventDTOFromJSONTyped,
    EventDTOToJSON,
    EventDTOToJSONTyped,
} from './EventDTO';
import type { WorkOtherTitleDTO } from './WorkOtherTitleDTO';
import {
    WorkOtherTitleDTOFromJSON,
    WorkOtherTitleDTOFromJSONTyped,
    WorkOtherTitleDTOToJSON,
    WorkOtherTitleDTOToJSONTyped,
} from './WorkOtherTitleDTO';
import type { WorkTitleAbbreviationDTO } from './WorkTitleAbbreviationDTO';
import {
    WorkTitleAbbreviationDTOFromJSON,
    WorkTitleAbbreviationDTOFromJSONTyped,
    WorkTitleAbbreviationDTOToJSON,
    WorkTitleAbbreviationDTOToJSONTyped,
} from './WorkTitleAbbreviationDTO';
import type { WorkRelatedIdentifierInternalDTO } from './WorkRelatedIdentifierInternalDTO';
import {
    WorkRelatedIdentifierInternalDTOFromJSON,
    WorkRelatedIdentifierInternalDTOFromJSONTyped,
    WorkRelatedIdentifierInternalDTOToJSON,
    WorkRelatedIdentifierInternalDTOToJSONTyped,
} from './WorkRelatedIdentifierInternalDTO';
import type { WorkOrganisationDTO } from './WorkOrganisationDTO';
import {
    WorkOrganisationDTOFromJSON,
    WorkOrganisationDTOFromJSONTyped,
    WorkOrganisationDTOToJSON,
    WorkOrganisationDTOToJSONTyped,
} from './WorkOrganisationDTO';
import type { WorkPersonOtherDTO } from './WorkPersonOtherDTO';
import {
    WorkPersonOtherDTOFromJSON,
    WorkPersonOtherDTOFromJSONTyped,
    WorkPersonOtherDTOToJSON,
    WorkPersonOtherDTOToJSONTyped,
} from './WorkPersonOtherDTO';
import type { WorkPersonDTO } from './WorkPersonDTO';
import {
    WorkPersonDTOFromJSON,
    WorkPersonDTOFromJSONTyped,
    WorkPersonDTOToJSON,
    WorkPersonDTOToJSONTyped,
} from './WorkPersonDTO';
import type { WorkIsPartOfOtherDTO } from './WorkIsPartOfOtherDTO';
import {
    WorkIsPartOfOtherDTOFromJSON,
    WorkIsPartOfOtherDTOFromJSONTyped,
    WorkIsPartOfOtherDTOToJSON,
    WorkIsPartOfOtherDTOToJSONTyped,
} from './WorkIsPartOfOtherDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';
import type { WorkKeywordDTO } from './WorkKeywordDTO';
import {
    WorkKeywordDTOFromJSON,
    WorkKeywordDTOFromJSONTyped,
    WorkKeywordDTOToJSON,
    WorkKeywordDTOToJSONTyped,
} from './WorkKeywordDTO';

/**
 * 
 * @export
 * @interface WorkDTO
 */
export interface WorkDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkDTO
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkDTO
     */
    canEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkDTO
     */
    canDelete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkDTO
     */
    canRequestDelete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    applicationCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    applicationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    edition?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    formSubject?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    format?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    grantNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkDTO
     */
    issued?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    numberOfPages?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    numberOfVolumes?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    oldId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    patentFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    patentId?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    patentType?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    peerReviewed?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    priorityCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    priorityNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkDTO
     */
    priorityPatentApplication?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    publicationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    publicationStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    pubtype?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    resourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    size?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    subseriesTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    subtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    titleSupplement?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkDTO
     */
    dataVersion?: string;
    /**
     * 
     * @type {AdminDataWorkDTO}
     * @memberof WorkDTO
     */
    adminDataWork?: AdminDataWorkDTO;
    /**
     * 
     * @type {Array<EventDTO>}
     * @memberof WorkDTO
     */
    events?: Array<EventDTO>;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof WorkDTO
     */
    externalIds?: Array<ExternalIdDTO>;
    /**
     * 
     * @type {Array<UrlDTO>}
     * @memberof WorkDTO
     */
    urls?: Array<UrlDTO>;
    /**
     * 
     * @type {Array<WorkKeywordDTO>}
     * @memberof WorkDTO
     */
    workKeywords?: Array<WorkKeywordDTO>;
    /**
     * 
     * @type {Array<WorkPublisherDTO>}
     * @memberof WorkDTO
     */
    workPublishers?: Array<WorkPublisherDTO>;
    /**
     * 
     * @type {Array<WorkPersonDTO>}
     * @memberof WorkDTO
     */
    workPersons?: Array<WorkPersonDTO>;
    /**
     * 
     * @type {Array<WorkOrganisationDTO>}
     * @memberof WorkDTO
     */
    workOrganisations?: Array<WorkOrganisationDTO>;
    /**
     * 
     * @type {Array<WorkOrganisationOtherDTO>}
     * @memberof WorkDTO
     */
    workOrganisationOthers?: Array<WorkOrganisationOtherDTO>;
    /**
     * 
     * @type {Array<WorkProjectDTO>}
     * @memberof WorkDTO
     */
    workProjects?: Array<WorkProjectDTO>;
    /**
     * 
     * @type {Array<WorkProjectOtherDTO>}
     * @memberof WorkDTO
     */
    workProjectOthers?: Array<WorkProjectOtherDTO>;
    /**
     * 
     * @type {Array<WorkDescriptionDTO>}
     * @memberof WorkDTO
     */
    workDescriptions?: Array<WorkDescriptionDTO>;
    /**
     * 
     * @type {Array<WorkDateTypeDTO>}
     * @memberof WorkDTO
     */
    workDateTypes?: Array<WorkDateTypeDTO>;
    /**
     * 
     * @type {Array<WorkIsPartOfDTO>}
     * @memberof WorkDTO
     */
    workIsPartOfs?: Array<WorkIsPartOfDTO>;
    /**
     * 
     * @type {Array<WorkIsPartOfOtherDTO>}
     * @memberof WorkDTO
     */
    workIsPartOfOthers?: Array<WorkIsPartOfOtherDTO>;
    /**
     * 
     * @type {Array<WorkLanguageDTO>}
     * @memberof WorkDTO
     */
    workLanguages?: Array<WorkLanguageDTO>;
    /**
     * 
     * @type {Array<WorkOtherTitleDTO>}
     * @memberof WorkDTO
     */
    workOtherTitles?: Array<WorkOtherTitleDTO>;
    /**
     * 
     * @type {Array<WorkPersonOtherDTO>}
     * @memberof WorkDTO
     */
    workPersonOthers?: Array<WorkPersonOtherDTO>;
    /**
     * 
     * @type {Array<WorkPlaceDTO>}
     * @memberof WorkDTO
     */
    workPlaces?: Array<WorkPlaceDTO>;
    /**
     * 
     * @type {Array<WorkRelatedIdentifierDTO>}
     * @memberof WorkDTO
     */
    externalRelatedIdentifiers?: Array<WorkRelatedIdentifierDTO>;
    /**
     * 
     * @type {Array<WorkRelatedIdentifierInternalDTO>}
     * @memberof WorkDTO
     */
    internalRelatedIdentifiersSource?: Array<WorkRelatedIdentifierInternalDTO>;
    /**
     * 
     * @type {Array<WorkRelatedIdentifierInternalDTO>}
     * @memberof WorkDTO
     */
    internalRelatedIdentifiersTarget?: Array<WorkRelatedIdentifierInternalDTO>;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof WorkDTO
     */
    workSubjects?: Array<SubjectDTO>;
    /**
     * 
     * @type {Array<WorkTitleAbbreviationDTO>}
     * @memberof WorkDTO
     */
    workTitleAbbreviations?: Array<WorkTitleAbbreviationDTO>;
    /**
     * 
     * @type {Array<WorkHasPartDTO>}
     * @memberof WorkDTO
     */
    workHasParts?: Array<WorkHasPartDTO>;
    /**
     * 
     * @type {Array<WorkGeoLocationDTO>}
     * @memberof WorkDTO
     */
    workGeoLocations?: Array<WorkGeoLocationDTO>;
}

/**
 * Check if a given object implements the WorkDTO interface.
 */
export function instanceOfWorkDTO(value: object): value is WorkDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function WorkDTOFromJSON(json: any): WorkDTO {
    return WorkDTOFromJSONTyped(json, false);
}

export function WorkDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'],
                  'canEdit': json['canEdit'] == null ? undefined : json['canEdit'],
                  'canDelete': json['canDelete'] == null ? undefined : json['canDelete'],
                  'canRequestDelete': json['canRequestDelete'] == null ? undefined : json['canRequestDelete'],
                  'applicationCountry': json['applicationCountry'] == null ? undefined : json['applicationCountry'],
                  'applicationNumber': json['applicationNumber'] == null ? undefined : json['applicationNumber'],
                  'edition': json['edition'] == null ? undefined : json['edition'],
                  'formSubject': json['formSubject'] == null ? undefined : json['formSubject'],
                  'format': json['format'] == null ? undefined : json['format'],
                  'grantNumber': json['grantNumber'] == null ? undefined : json['grantNumber'],
                  'issued': json['issued'] == null ? undefined : json['issued'],
                  'medium': json['medium'] == null ? undefined : json['medium'],
                  'note': json['note'] == null ? undefined : json['note'],
                  'number': json['number'] == null ? undefined : json['number'],
                  'numberOfPages': json['numberOfPages'] == null ? undefined : json['numberOfPages'],
                  'numberOfVolumes': json['numberOfVolumes'] == null ? undefined : json['numberOfVolumes'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                  'patentFamily': json['patentFamily'] == null ? undefined : json['patentFamily'],
                  'patentId': json['patentId'] == null ? undefined : json['patentId'],
                  'patentType': json['patentType'] == null ? undefined : json['patentType'],
                  'peerReviewed': json['peerReviewed'] == null ? undefined : json['peerReviewed'],
                  'priorityCountry': json['priorityCountry'] == null ? undefined : json['priorityCountry'],
                  'priorityNumber': json['priorityNumber'] == null ? undefined : json['priorityNumber'],
                  'priorityPatentApplication': json['priorityPatentApplication'] == null ? undefined : json['priorityPatentApplication'],
                  'publicationNumber': json['publicationNumber'] == null ? undefined : json['publicationNumber'],
                  'publicationStatus': json['publicationStatus'] == null ? undefined : json['publicationStatus'],
                  'pubtype': json['pubtype'] == null ? undefined : json['pubtype'],
                  'resourceType': json['resourceType'] == null ? undefined : json['resourceType'],
                  'size': json['size'] == null ? undefined : json['size'],
                  'subseriesTitle': json['subseriesTitle'] == null ? undefined : json['subseriesTitle'],
                  'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
                  'title': json['title'] == null ? undefined : json['title'],
                  'titleSupplement': json['titleSupplement'] == null ? undefined : json['titleSupplement'],
                  'version': json['version'] == null ? undefined : json['version'],
                  'dataVersion': json['dataVersion'] == null ? undefined : json['dataVersion'],
                  'adminDataWork': json['adminDataWork'] == null ? undefined : AdminDataWorkDTOFromJSON(json['adminDataWork']),
              'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(EventDTOFromJSON)),
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
              'urls': json['urls'] == null ? undefined : ((json['urls'] as Array<any>).map(UrlDTOFromJSON)),
              'workKeywords': json['workKeywords'] == null ? undefined : ((json['workKeywords'] as Array<any>).map(WorkKeywordDTOFromJSON)),
              'workPublishers': json['workPublishers'] == null ? undefined : ((json['workPublishers'] as Array<any>).map(WorkPublisherDTOFromJSON)),
              'workPersons': json['workPersons'] == null ? undefined : ((json['workPersons'] as Array<any>).map(WorkPersonDTOFromJSON)),
              'workOrganisations': json['workOrganisations'] == null ? undefined : ((json['workOrganisations'] as Array<any>).map(WorkOrganisationDTOFromJSON)),
              'workOrganisationOthers': json['workOrganisationOthers'] == null ? undefined : ((json['workOrganisationOthers'] as Array<any>).map(WorkOrganisationOtherDTOFromJSON)),
              'workProjects': json['workProjects'] == null ? undefined : ((json['workProjects'] as Array<any>).map(WorkProjectDTOFromJSON)),
              'workProjectOthers': json['workProjectOthers'] == null ? undefined : ((json['workProjectOthers'] as Array<any>).map(WorkProjectOtherDTOFromJSON)),
              'workDescriptions': json['workDescriptions'] == null ? undefined : ((json['workDescriptions'] as Array<any>).map(WorkDescriptionDTOFromJSON)),
              'workDateTypes': json['workDateTypes'] == null ? undefined : ((json['workDateTypes'] as Array<any>).map(WorkDateTypeDTOFromJSON)),
              'workIsPartOfs': json['workIsPartOfs'] == null ? undefined : ((json['workIsPartOfs'] as Array<any>).map(WorkIsPartOfDTOFromJSON)),
              'workIsPartOfOthers': json['workIsPartOfOthers'] == null ? undefined : ((json['workIsPartOfOthers'] as Array<any>).map(WorkIsPartOfOtherDTOFromJSON)),
              'workLanguages': json['workLanguages'] == null ? undefined : ((json['workLanguages'] as Array<any>).map(WorkLanguageDTOFromJSON)),
              'workOtherTitles': json['workOtherTitles'] == null ? undefined : ((json['workOtherTitles'] as Array<any>).map(WorkOtherTitleDTOFromJSON)),
              'workPersonOthers': json['workPersonOthers'] == null ? undefined : ((json['workPersonOthers'] as Array<any>).map(WorkPersonOtherDTOFromJSON)),
              'workPlaces': json['workPlaces'] == null ? undefined : ((json['workPlaces'] as Array<any>).map(WorkPlaceDTOFromJSON)),
              'externalRelatedIdentifiers': json['externalRelatedIdentifiers'] == null ? undefined : ((json['externalRelatedIdentifiers'] as Array<any>).map(WorkRelatedIdentifierDTOFromJSON)),
              'internalRelatedIdentifiersSource': json['internalRelatedIdentifiersSource'] == null ? undefined : ((json['internalRelatedIdentifiersSource'] as Array<any>).map(WorkRelatedIdentifierInternalDTOFromJSON)),
              'internalRelatedIdentifiersTarget': json['internalRelatedIdentifiersTarget'] == null ? undefined : ((json['internalRelatedIdentifiersTarget'] as Array<any>).map(WorkRelatedIdentifierInternalDTOFromJSON)),
              'workSubjects': json['workSubjects'] == null ? undefined : ((json['workSubjects'] as Array<any>).map(SubjectDTOFromJSON)),
              'workTitleAbbreviations': json['workTitleAbbreviations'] == null ? undefined : ((json['workTitleAbbreviations'] as Array<any>).map(WorkTitleAbbreviationDTOFromJSON)),
              'workHasParts': json['workHasParts'] == null ? undefined : ((json['workHasParts'] as Array<any>).map(WorkHasPartDTOFromJSON)),
              'workGeoLocations': json['workGeoLocations'] == null ? undefined : ((json['workGeoLocations'] as Array<any>).map(WorkGeoLocationDTOFromJSON)),
    };
}

export function WorkDTOToJSON(json: any): WorkDTO {
    return WorkDTOToJSONTyped(json, false);
}

export function WorkDTOToJSONTyped(value?: WorkDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'canEdit': value['canEdit'],
        'canDelete': value['canDelete'],
        'canRequestDelete': value['canRequestDelete'],
        'applicationCountry': value['applicationCountry'],
        'applicationNumber': value['applicationNumber'],
        'edition': value['edition'],
        'formSubject': value['formSubject'],
        'format': value['format'],
        'grantNumber': value['grantNumber'],
        'issued': value['issued'],
        'medium': value['medium'],
        'note': value['note'],
        'number': value['number'],
        'numberOfPages': value['numberOfPages'],
        'numberOfVolumes': value['numberOfVolumes'],
        'oldId': value['oldId'],
        'patentFamily': value['patentFamily'],
        'patentId': value['patentId'],
        'patentType': value['patentType'],
        'peerReviewed': value['peerReviewed'],
        'priorityCountry': value['priorityCountry'],
        'priorityNumber': value['priorityNumber'],
        'priorityPatentApplication': value['priorityPatentApplication'],
        'publicationNumber': value['publicationNumber'],
        'publicationStatus': value['publicationStatus'],
        'pubtype': value['pubtype'],
        'resourceType': value['resourceType'],
        'size': value['size'],
        'subseriesTitle': value['subseriesTitle'],
        'subtitle': value['subtitle'],
        'title': value['title'],
        'titleSupplement': value['titleSupplement'],
        'version': value['version'],
        'dataVersion': value['dataVersion'],
        'adminDataWork': AdminDataWorkDTOToJSON(value['adminDataWork']),
        'events': value['events'] == null? value['events']: (value['events'] as Array<any>).map(EventDTOToJSON),
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
        'urls': value['urls'] == null? value['urls']: (value['urls'] as Array<any>).map(UrlDTOToJSON),
        'workKeywords': value['workKeywords'] == null? value['workKeywords']: (value['workKeywords'] as Array<any>).map(WorkKeywordDTOToJSON),
        'workPublishers': value['workPublishers'] == null? value['workPublishers']: (value['workPublishers'] as Array<any>).map(WorkPublisherDTOToJSON),
        'workPersons': value['workPersons'] == null? value['workPersons']: (value['workPersons'] as Array<any>).map(WorkPersonDTOToJSON),
        'workOrganisations': value['workOrganisations'] == null? value['workOrganisations']: (value['workOrganisations'] as Array<any>).map(WorkOrganisationDTOToJSON),
        'workOrganisationOthers': value['workOrganisationOthers'] == null? value['workOrganisationOthers']: (value['workOrganisationOthers'] as Array<any>).map(WorkOrganisationOtherDTOToJSON),
        'workProjects': value['workProjects'] == null? value['workProjects']: (value['workProjects'] as Array<any>).map(WorkProjectDTOToJSON),
        'workProjectOthers': value['workProjectOthers'] == null? value['workProjectOthers']: (value['workProjectOthers'] as Array<any>).map(WorkProjectOtherDTOToJSON),
        'workDescriptions': value['workDescriptions'] == null? value['workDescriptions']: (value['workDescriptions'] as Array<any>).map(WorkDescriptionDTOToJSON),
        'workDateTypes': value['workDateTypes'] == null? value['workDateTypes']: (value['workDateTypes'] as Array<any>).map(WorkDateTypeDTOToJSON),
        'workIsPartOfs': value['workIsPartOfs'] == null? value['workIsPartOfs']: (value['workIsPartOfs'] as Array<any>).map(WorkIsPartOfDTOToJSON),
        'workIsPartOfOthers': value['workIsPartOfOthers'] == null? value['workIsPartOfOthers']: (value['workIsPartOfOthers'] as Array<any>).map(WorkIsPartOfOtherDTOToJSON),
        'workLanguages': value['workLanguages'] == null? value['workLanguages']: (value['workLanguages'] as Array<any>).map(WorkLanguageDTOToJSON),
        'workOtherTitles': value['workOtherTitles'] == null? value['workOtherTitles']: (value['workOtherTitles'] as Array<any>).map(WorkOtherTitleDTOToJSON),
        'workPersonOthers': value['workPersonOthers'] == null? value['workPersonOthers']: (value['workPersonOthers'] as Array<any>).map(WorkPersonOtherDTOToJSON),
        'workPlaces': value['workPlaces'] == null? value['workPlaces']: (value['workPlaces'] as Array<any>).map(WorkPlaceDTOToJSON),
        'externalRelatedIdentifiers': value['externalRelatedIdentifiers'] == null? value['externalRelatedIdentifiers']: (value['externalRelatedIdentifiers'] as Array<any>).map(WorkRelatedIdentifierDTOToJSON),
        'internalRelatedIdentifiersSource': value['internalRelatedIdentifiersSource'] == null? value['internalRelatedIdentifiersSource']: (value['internalRelatedIdentifiersSource'] as Array<any>).map(WorkRelatedIdentifierInternalDTOToJSON),
        'internalRelatedIdentifiersTarget': value['internalRelatedIdentifiersTarget'] == null? value['internalRelatedIdentifiersTarget']: (value['internalRelatedIdentifiersTarget'] as Array<any>).map(WorkRelatedIdentifierInternalDTOToJSON),
        'workSubjects': value['workSubjects'] == null? value['workSubjects']: (value['workSubjects'] as Array<any>).map(SubjectDTOToJSON),
        'workTitleAbbreviations': value['workTitleAbbreviations'] == null? value['workTitleAbbreviations']: (value['workTitleAbbreviations'] as Array<any>).map(WorkTitleAbbreviationDTOToJSON),
        'workHasParts': value['workHasParts'] == null? value['workHasParts']: (value['workHasParts'] as Array<any>).map(WorkHasPartDTOToJSON),
        'workGeoLocations': value['workGeoLocations'] == null? value['workGeoLocations']: (value['workGeoLocations'] as Array<any>).map(WorkGeoLocationDTOToJSON),
    };
}


